import React from "react";
import { Box, Typography } from "@mui/material";

// Replace with actual background image path when available
import bgBlock from "../assets/joma/bg-block.png";

const StoreCard = ({ store }) => {
  return (
    <Box
      onClick={() => {
        window.location.href = "https://pide.mennu.mx/jomar";
      }}
      sx={{
        width: "100%",
        height: { xs: 120, sm: 140 }, // Slightly shorter on mobile to fit 2 columns better
        backgroundImage: `url(${bgBlock})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "12px",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
        },
      }}
    >
      {/* Semi-transparent blue overlay if needed (the image might already have it) */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(30, 60, 140, 0.4)", // Adjust color and opacity to match design
          zIndex: 1,
        }}
      />
      
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          textAlign: "center",
          px: 1, // Reduced padding to fit better in two columns on mobile
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            color: "white",
            fontWeight: "bold",
            mb: 0.5,
            textShadow: "1px 1px 3px rgba(0,0,0,0.8)", // Stronger text shadow
            fontSize: { xs: "0.8rem", sm: "0.95rem" }, // Smaller on mobile
            lineHeight: 1.1,
          }}
        >
          {store.name.split(' ')[0]} {/* e.g., "Sucursal" */}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: "white",
            fontWeight: 800,
            lineHeight: 1.1,
            mb: 1,
            textShadow: "1px 1px 4px rgba(0,0,0,0.9)", // Stronger text shadow
            fontSize: { xs: "1.1rem", sm: "1.3rem" }, // Smaller on mobile
            wordBreak: "break-word",
          }}
        >
          {store.name.split(' ').slice(1).join(' ')} {/* e.g., "Monterrey 1" */}
        </Typography>
        <Box 
          sx={{ 
            backgroundColor: "rgba(0, 0, 0, 0.45)", // Semi-transparent dark background
            padding: "2px 6px", // Reduced padding
            borderRadius: "6px",
            display: "inline-block" // So it only takes up as much width as the text
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: "#ffffff", // Pure white for better contrast
              display: "block",
              fontSize: { xs: "0.6rem", sm: "0.75rem" }, // Make it smaller on mobile so it fits in 2 columns
              fontWeight: 600, // Make it slightly bolder
              lineHeight: 1.3,
            }}
          >
            {store.hours.split(" | ")[0]}<br/>
            {store.hours.split(" | ")[1]}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default StoreCard;
